import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AccountV2ViewComponentDef } from '@df/account/v2/view/account-v2-view.component.def';
import { ICmsOutletBlockComponent } from '../../catalog/block/icms-outlet-block.component';
import { AccountGreetingComponent } from '../greeting/account-greeting.component';
import { AccountNavigationComponent } from '../navigation/account-navigation.component';
import { IfSizeDirective } from '@df/ui/common/if-size.directive';
@Component({
    selector: 'account-view',
    templateUrl: './account-view.html',
    styleUrls: ['./account-view.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [ICmsOutletBlockComponent, RouterModule, AccountNavigationComponent, AccountGreetingComponent, CommonModule, IfSizeDirective]
})
export class AccountViewComponent extends AccountV2ViewComponentDef {
    private _forceContentCols: number | undefined = 7;
    get forceContentCols() {
        return this._forceContentCols;
    }
    set forceContentCols(value) {
        if (this._forceContentCols !== value) {
            this._forceContentCols = value;
            this.detectChanges();
        }
    }
}
